import { Tooltip } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import BarChartIcon from "@material-ui/icons/BarChart";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ReceiptIcon from "@material-ui/icons/Receipt";
import CachedIcon from "@material-ui/icons/Cached";
import SettingsIcon from "@material-ui/icons/Settings";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode, faExchangeAlt } from "@fortawesome/free-solid-svg-icons";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import PublishIcon from "@material-ui/icons/Publish";
import Notes from "@material-ui/icons/RateReview";
import { useHistory } from "react-router-dom";
import { LocalAtm } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default function MenuListItems(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const { menuItems, showSectionTop } = props;
  const history = useHistory();

  const inventoryManagement = menuItems?.find(
    (item) => item.modulename === "Inventory Management"
  );

  const reportManagement = menuItems?.find(
    (item) => item.modulename === "Report Management"
  );
  //Analytics Management
  const analyticsManagement = menuItems?.find(
    (item) => item.modulename === "Analytics Management"
  );

  const assetManagement = menuItems?.find(
    (item) => item.modulename === "Asset Management"
  );
  const licenseManagement = menuItems?.find(
    (item) => item.modulename === "License Management"
  );
  const employeeManagement = menuItems?.find(
    (item) => item.modulename === "Employee Management"
  );
  const supplierManagement = menuItems?.find(
    (item) => item.modulename === "Supplier Management"
  );

  const [openReportMenu, setOpenReportMenu] = React.useState(false);
  const [openSettingsMenu, setOpenSettingsMenu] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleReportMenuClick = () => {
    setOpenReportMenu(!openReportMenu);
  };

  const handleSettingsMenuClick = () => {
    setOpenSettingsMenu(!openSettingsMenu);
  };

  return (
    <div>
      {inventoryManagement && showSectionTop && (
        <Tooltip title="Menu">
          <ListItem button onClick={handleClick}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Inventory" />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
        </Tooltip>
      )}

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Tooltip title="Goods Receivables">
            <ListItem
              button
              className={classes.nested}
              component="a"
              onClick={() => history.push("/captureReceivedGoods")}
            >
              <ListItemIcon>
                <FontAwesomeIcon icon={faBarcode} size="lg" />
              </ListItemIcon>
              <ListItemText primary="Goods Receivables" />
            </ListItem>
          </Tooltip>
          <Tooltip title="Saleable Returns">
            <ListItem
              button
              className={classes.nested}
              component="a"
              onClick={() => history.push("/inventory/saleablereturn")}
            >
              <ListItemIcon>
                <AttachMoneyIcon />
              </ListItemIcon>
              <ListItemText primary="Saleable Returns" />
            </ListItem>
          </Tooltip>
          <Tooltip title="Non Saleable Returns">
            <ListItem
              button
              className={classes.nested}
              component="a"
              onClick={() => history.push("/inventory/nonsaleablereturn")}
            >
              <ListItemIcon>
                <FontAwesomeIcon icon={faExchangeAlt} size="lg" />
              </ListItemIcon>
              <ListItemText primary="Non Saleable Returns" />
            </ListItem>
          </Tooltip>
          <Tooltip title="Physical Inventory">
            <ListItem
              button
              className={classes.nested}
              component="a"
              onClick={() => history.push("/physicalInventory")}
            >
              <ListItemIcon>
                <Notes />
              </ListItemIcon>
              <ListItemText primary="Physical Inventory" />
            </ListItem>
          </Tooltip>
        </List>
      </Collapse>
      {analyticsManagement && showSectionTop && (
        <>
          <Tooltip title="Upload">
            <ListItem
              button
              component="a"
              onClick={() => history.push("/uploads")}
            >
              <ListItemIcon>
                <PublishIcon />
              </ListItemIcon>
              <ListItemText primary="Upload" />
            </ListItem>
          </Tooltip>
        </>
      )}
      {reportManagement && showSectionTop && (
        <>
          <Tooltip title="Analytical Reports">
            <ListItem button onClick={handleReportMenuClick}>
              <ListItemIcon>
                <BarChartIcon />
              </ListItemIcon>
              <ListItemText primary="Analytical Reports" />
              {openReportMenu ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
          </Tooltip>
          <Collapse in={openReportMenu} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <Tooltip title="Goods Receivable (GR) Report">
                <ListItem
                  button
                  className={classes.nested}
                  component="a"
                  onClick={() =>
                    history.push("/reports/recentCapturedGoodsReport")
                  }
                >
                  <ListItemIcon>
                    <ReceiptIcon />
                  </ListItemIcon>
                  <ListItemText primary="Goods Receivable (GR) Report" />
                </ListItem>
              </Tooltip>
              <Tooltip title="Inventory Reconcillation Report">
                <ListItem
                  button
                  className={classes.nested}
                  component="a"
                  onClick={() => history.push("/reports/reconcillationReport")}
                >
                  <ListItemIcon>
                    <CachedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Inventory Recon" />
                </ListItem>
              </Tooltip>
              <Tooltip title="Saleable Return RA Reconcilation Report">
                <ListItem
                  button
                  className={classes.nested}
                  component="a"
                  onClick={() =>
                    history.push("/reports/saleableReturnReconcillationReport")
                  }
                >
                  <ListItemIcon>
                    <AttachMoneyIcon />
                  </ListItemIcon>
                  <ListItemText primary="Saleable Return RA Recon" />
                </ListItem>
              </Tooltip>
              <Tooltip title="Physical Inventory Report">
                <ListItem
                  button
                  className={classes.nested}
                  component="a"
                  onClick={() =>
                    history.push("/reports/physicalInventoryReport")
                  }
                >
                  <ListItemIcon>
                    <Notes />
                  </ListItemIcon>
                  <ListItemText primary="Physical Inventory Report" />
                </ListItem>
              </Tooltip>
              <Tooltip title="PI Cost Report">
                <ListItem
                  button
                  className={classes.nested}
                  component="a"
                  onClick={() =>
                    history.push("/reports/physicalInventoryCostReport")
                  }
                >
                  <ListItemIcon>
                    <LocalAtm />
                  </ListItemIcon>
                  <ListItemText primary="PI Cost Report" />
                </ListItem>
              </Tooltip>
            </List>
          </Collapse>
        </>
      )}
      {(assetManagement ||
        licenseManagement ||
        supplierManagement ||
        employeeManagement) &&
        !showSectionTop && (
          <>
            <Tooltip title="Settings">
              <ListItem button onClick={handleSettingsMenuClick}>
                <ListItemIcon>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText primary="Settings" />
                {openSettingsMenu ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </Tooltip>
            <Collapse in={openSettingsMenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <Tooltip title="Supplier">
                  <ListItem
                    button
                    component="a"
                    className={classes.nested}
                    onClick={() =>
                      history.push("/ancillary/supplierManagement")
                    }
                  >
                    <ListItemIcon>
                      <LocalShippingIcon />
                    </ListItemIcon>
                    <ListItemText primary="Supplier" />
                  </ListItem>
                </Tooltip>
                <Tooltip title="Asset Management">
                  <ListItem
                    button
                    component="a"
                    className={classes.nested}
                    onClick={() => history.push("/assetManagement")}
                  >
                    <ListItemIcon>
                      <ShoppingCartIcon />
                    </ListItemIcon>
                    <ListItemText primary="Asset Management" />
                  </ListItem>
                </Tooltip>
                <Tooltip title="License Management">
                  <ListItem
                    button
                    component="a"
                    className={classes.nested}
                    onClick={() => history.push("/ancillary/licenseManagement")}
                  >
                    <ListItemIcon>
                      <AllInboxIcon />
                    </ListItemIcon>
                    <ListItemText primary="License Management" />
                  </ListItem>
                </Tooltip>
                <Tooltip title="Manage Employee">
                  <ListItem
                    button
                    component="a"
                    className={classes.nested}
                    onClick={() => history.push("/employeeManagement")}
                  >
                    <ListItemIcon>
                      <PersonAddIcon />
                    </ListItemIcon>
                    <ListItemText primary="Manage Employee" />
                  </ListItem>
                </Tooltip>
              </List>
            </Collapse>
          </>
        )}
    </div>
  );
}
